import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {User} from "src/app/modules/auth/models/User";
import {ProfileMenuComponent} from "../profile-menu/profile-menu.component";
import {RouterLink} from "@angular/router";
import {NotificationsComponent} from "../notifications/notifications.component";
import {TranslateModule} from "@ngx-translate/core";
import {DiscussionsButtonComponent} from "src/app/modules/discussions/components/discussions-button/discussions-button.component";

@Component({
  selector: "app-header-mobile",
  templateUrl: "./header-mobile.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "block min-h-[var(--header-height-mobile)]",
  },
  imports: [
    ProfileMenuComponent,
    RouterLink,
    NotificationsComponent,
    TranslateModule,
    DiscussionsButtonComponent,
  ],
})
export class HeaderMobileComponent {
  @Input() user?: User;
}
